"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = void 0;
const react_1 = __importDefault(require("react"));
const util_1 = require("./util");
const allow_head_type = {
    base: true,
    link: true,
    style: true,
    meta: true,
    title: true,
};
const Head = props => {
    const { children } = props;
    const pushChild = [];
    util_1.flattenElements(children, allow_head_type, pushChild);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("meta", { charSet: "UTF-8" }),
        react_1.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0" }),
        pushChild));
};
exports.Head = Head;
//# sourceMappingURL=Head.js.map